var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PopupContent',{attrs:{"id":"mapPopup","graph-id":_vm.graphId,"disable-chart":_vm.isMobile,"popup-details":_vm.popupDetails,"title-prop":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }